module.exports = __webpack_public_path__ + "img/illustration_mobile_arab.b161dd20.png";